import { createRoot } from 'react-dom/client';
import {
    BrowserRouter, Routes, Route, useNavigate,
} from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import Home from './components/pages/Home';
import Mission from './components/pages/Mission';
import About from './components/pages/About';
import Members from './components/pages/Members';
import Samples from './components/pages/Samples';
import Contact from './components/pages/Contact';
import AccessCode from './components/pages/AccessCode';
import App from './App';
import Admin from './components/admin/Admin';
import ProtectedRoute from './components/ProtectedRoute';
import SchoolLogin from './components/pages/SchoolLogin';
import PurchaseConfirmation from './components/PurchaseConfirmation';
import authSessionCache from './service/authSessionCache';

const domNode = document.getElementById('root');
const root = createRoot(domNode);

const auth0Config = {
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    rolesClaim: process.env.REACT_APP_AUTH0_ROLES_CLAIM,
};

const missingAuth0Variables = Object.entries(auth0Config)
    .filter(([, value]) => !value)
    .map(([name]) => name);

if (missingAuth0Variables.length > 0) {
    throw new Error(`Missing required Auth0 configuration: ${missingAuth0Variables.join(', ')}`);
}

function Auth0ProviderWithNavigate() {
    const navigate = useNavigate();

    return (
        <Auth0Provider
            cache={authSessionCache}
            onRedirectCallback={(appState) => {
                navigate(appState?.returnTo || window.location.pathname, { replace: true });
            }}
            domain={auth0Config.domain}
            clientId={auth0Config.clientId}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/members`,
                audience: auth0Config.audience,
                scope: 'openid profile email',
            }}>
            <Routes>
                <Route
                    path="/"
                    element={<App />}>
                    <Route
                        index
                        element={<Home />} />
                    <Route path="/admin/*" element={<Admin />} />
                    <Route
                        path="/mission"
                        element={<Mission />} />
                    <Route
                        path="/about"
                        element={<About />} />
                    <Route
                        path="/members"
                        element={<ProtectedRoute element={<Members />} />} />
                    <Route
                        path="/samples"
                        element={<Samples />} />
                    <Route
                        path="/contact"
                        element={<Contact />} />
                    <Route
                        path="/verify-access-code"
                        element={<AccessCode />} />
                    <Route
                        path="/school-login"
                        element={<SchoolLogin />} />
                    <Route
                        path="/purchase-confirmation"
                        element={<PurchaseConfirmation />} />
                </Route>
            </Routes>
        </Auth0Provider>
    );
}

root.render(
    <BrowserRouter>
        <Auth0ProviderWithNavigate />
    </BrowserRouter>,
);
